import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { io } from "socket.io-client";

import Menu from "../slideBar";
import "../logo/logo.css";
import "./nav.css";
const Navigation = ({ setShowSidbarMarginLeft, showSidbarMarginLeft }) => {
  const [notification, setNotification] = useState("");

  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/api/getNotification`)
      .then((respone) => {
        return respone.json();
      })
      .then((res) => {
        setNotification(res.finded.notification);
      })
      .catch((err) => {
        console.log(err);
      });
    const socket = io(`${process.env.REACT_APP_URL}`, {
      // transports: ["websocket"],
      transports: ["polling"],
    });

    socket.on("notification", (data) => {
      setNotification(data.notification);
    });
  }, [setNotification]);

  return (
    <div className="font-semibold  mx-auto w-[95%] ">
      <ul
        className="flex flex-row-reverse justify-center 
      screen900:text-sm screen600:text-[12px] 
      screen500:invisible
      "
      >
        <NavLink
          className={({ isActive }) => (isActive ? "text-[#faf838]" : "")}
          to="/"
        >
          <li className="p-6 screen700:p-3 screen500:p-2 screen400:p-1">
            صفحه اصلی
          </li>
        </NavLink>
        <NavLink
          className={({ isActive }) => (isActive ? "text-[#faf838]" : "")}
          to="/gallery"
        >
          <li className="p-6 screen700:p-3 screen500:p-2 screen400:p-1">
            گالری
          </li>
        </NavLink>
        <NavLink
          className={({ isActive }) => (isActive ? "text-[#faf838]" : "")}
          to="/forms"
        >
          <li className="p-6 screen700:p-3 screen500:p-2 screen400:p-1">
            فرم ها
          </li>
        </NavLink>
        <NavLink
          className={({ isActive }) => (isActive ? "text-[#faf838]" : "")}
          to="/queue-sysem"
        >
          <li className="p-6 screen700:p-3 screen500:p-2 screen400:p-1">
            نوبت دهی
          </li>
        </NavLink>
        <NavLink
          className={({ isActive }) => (isActive ? "text-[#faf838]" : "")}
          to="/comment"
        >
          <li className="p-6 screen700:p-3 screen500:p-2 screen400:p-1">
            ثبت نظر
          </li>
        </NavLink>
        <NavLink
          className={({ isActive }) => (isActive ? "text-[#faf838]" : "")}
          to="/about-us"
        >
          <li className="p-6 screen700:p-3 screen500:p-2 screen400:p-1">
            درباره ما
          </li>
        </NavLink>
      </ul>

      <div
        style={{ direction: "rtl" }}
        className={`text-center screen500:mt-6  mx-auto ${
          notification.trim().length === 0 && "invisible"
        } `}
      >
        <span
          className={`font-bold screen500:h-[24px]   ${
            showSidbarMarginLeft ? "text-[10px]" : "screen700:text-xs "
          }`}
        >
          اطلاعیه :
        </span>
        <div className="w-[90%] mx-auto screen500:overflow-hidden">
          <span
            className={`font-normal notif  w-[98%] ${
              showSidbarMarginLeft ? "text-[10px]" : "text-sm screen700:text-xs"
            }`}
          >
            {notification}
          </span>
        </div>
      </div>

      <div className="hidden screen500:grid ">
        <Menu setShowSidbarMarginLeft={setShowSidbarMarginLeft} />
      </div>

      <div className=" lines-class pt-16 grid grid-cols-3 ">
        <div className="border-b w-[70%] mx-auto "></div>
        <div className="border-b-0 "></div>
        <div className="border-b w-[70%] mx-auto"></div>
      </div>
    </div>
  );
};

export default Navigation;
